<div class="root-container">
  <form class="form-group" [formGroup]="form()">
    <div class="row pt-3">
      <div class="col-lg-4 col-md-6">
        <label class=" mb-2 label-required">Company / University</label>
        <div>
          <select formControlName="company_id" class="w-100" >
            @for (c of available_companies(); track c.uuid){
              <option [value]="c.uuid">{{ c.name | titlecase  }}</option>
            }
            <option value="others">Others (Specify)</option>
          </select>
        </div>
        @if (form().get('company_id')?.value == 'others'){
          <div class="my-2">
            <input type="text"
                   placeholder="Enter Company / University Name"
                   formControlName="company_university"
                   maxlength="100"/>
          </div>
        }
        <div class="error-label">
          <validation-error
            [form]="form()"
            controlName="company_university"
            [validation]="{
              required: 'Company is required',
              emojiNotAllowed: 'Emoji is not allowed',
              maxlength: 'Company must be 100 characters only'
            }"
          />
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <label for="position" class=" mb-2 label-required">Position</label>
        <input
          type="text"
          class="form-control"
          id="position"
          placeholder="Enter your Position"
          formControlName="position"
        />
        <div class="error-label">
          <validation-error
            [form]="form()"
            controlName="position"
            [validation]="{
              required: 'Position is required',
              emojiNotAllowed: 'Emoji is not allowed',
              pattern: 'Special characters are not allowed',
              maxlength: 'Position must be 100 characters only'
            }"
          />
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <label class=" mb-2 label-required">
          Sales Representative
        </label>
        <div>
          <select formControlName="fae_id"  class="w-100">
            <option selected disabled [value]="null">Select Representative</option>
            <option value="">None</option>
            @for (s of sales_reps;track s.uuid){
              <option [value]="s.uuid">{{ s.first_name | titlecase }} {{ s.last_name | titlecase }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <label for="category" class=" mb-2 label-title">
          School or Industry
        </label>
        <div class="d-flex gap-3">
          <input
            type="radio"
            id="school"
            name="category"
            formControlName="category"
            value="academe"
          />
          <label for="school" class="ml-2">School</label>

          <input
            type="radio"
            id="industry"
            name="category"
            formControlName="category"
            value="industrial"
          />
          <label for="industry" class="ml-2">Industry</label>
        </div>
        <div class="error-label">
          <validation-error
            [form]="form()"
            controlName="category"
            [validation]="{
            required: 'Please select an option',
          }"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <label for="sector" class=" mb-2 label-title">
          Sector
        </label>
        <div class="d-flex gap-3">
          <input
            type="radio"
            id="private"
            name="sector"
            formControlName="sector"
            value="private"
          />
          <label for="private" class="ml-2">Private</label>

          <input
            type="radio"
            id="government"
            name="sector"
            formControlName="sector"
            value="government"
          />
          <label for="government" class="ml-2">Government</label>
        </div>
        <div class="error-label">
          <validation-error
            [form]="form()"
            controlName="sector"
            [validation]="{
            required: 'Please select an option',
          }"
          />
        </div>
      </div>
    </div>
  </form>
</div>
